const BANNER_STORAGE_KEY = 'banner_viewed';

/**
 * Check if banner should be shown based on localStorage timestamp
 * @returns {boolean} true if banner should be shown, false otherwise
 */
export function shouldShowBanner(isParent) {
	try {
		if (isParent) {
			return false;
		}
		return true;

		const viewedTimestamp = localStorage.getItem(BANNER_STORAGE_KEY);

		// If no timestamp exists, show banner
		if (!viewedTimestamp) {
			return true;
		}

		const viewedDate = new Date(viewedTimestamp);
		const currentDate = new Date();
		const daysDifference = Math.floor((currentDate - viewedDate) / (1000 * 60 * 60 * 24));

		// Show banner if 7 or more days have passed
		return daysDifference >= 7;
	} catch (error) {
		// If there's any error with localStorage, show banner
		console.warn('Error checking banner visibility:', error);
		return true;
	}
}

/**
 * Mark banner as viewed with current timestamp
 */
export function markBannerAsViewed() {
	try {
		const currentTimestamp = new Date().toISOString();
		localStorage.setItem(BANNER_STORAGE_KEY, currentTimestamp);
	} catch (error) {
		console.warn('Error saving banner viewed timestamp:', error);
	}
}
